export enum MetricColour {
  Positive = 'bg-green-dark text-white dark:bg-green-dark dark:text-white',
  Neutral = 'bg-gray text-white dark:gray-dark dark:text-white',
  Negative = 'bg-pink-dark text-white dark:bg-pink-dark dark:text-white',
}
